"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultNewsAndInsights = void 0;
exports.defaultNewsAndInsights = {
    newsAndInsights: [
        {
            templateId: 745,
            content: '6 July 2018 - OKAY.com CEO Joshua Miller discusses what the new vacancy tax could mean for developers and consumers.\r\n\r\n\t \r\n\r\n\tThe Vacancy Tax - Structure\r\n\r\n\t \r\n\r\n\tOn June 30th, the government announ',
            title: 'Hong Kong’s New Vacancy Tax – Overview and Interpretation',
            url: 'https://dev.okay.com/en/property-news/hong-kongs-new-vacancy-tax--overview-and-interpretation/745',
            altText: 'Hong Kong’s New Vacancy Tax – Overview and Interpretation - Hong Kong Property Market News & Insights',
            imageUrl: 'https://images.okay.com/ContentThumbnail/Original/745_636664881884397316.jpg',
            authors: [
                {
                    name: 'Joshua Han Miller',
                    url: 'https://dev.okay.com/en/property-experts/joshua-han-miller/362',
                    id: 362,
                },
            ],
        },
        {
            templateId: 545,
            content: '19 July 2017 - Ten years ago, a development strategy for Hong Kong was produced by the Development Bureau and Planning department up to 2030. An update to the planning strategy looking beyond 2040 was',
            title: 'Country Parks or Artificial Land?',
            url: 'https://dev.okay.com/en/property-news/country-parks-or-artificial-land/545',
            altText: 'Housing shortage in Hong Kong',
            imageUrl: 'https://images.okay.com/ContentThumbnail/Original/545_636360857012287372.png',
            authors: [
                {
                    name: 'OKAY.com',
                    url: null,
                    id: 0,
                },
            ],
        },
    ],
    translate: {
        propertyNewsAndInsights: 'Property News & Insights',
        by: 'By',
        moreInsights: 'More Insights',
        youMayAlsoLike: 'You May Also Like',
    },
};
